// extracted by mini-css-extract-plugin
export default {"container":"mk-z","blurb":"nk-z","links":"ok-z"};